
import { $t } from '@/i18n';
import { CATEGORY } from './const';
import { nodeDiff3Text } from '@/utils/merge/textMerge';
export default [
  {
    id: 'utils:diff3',
    name: $t('k_58db280b'),
    desc: $t('k_42e604ca'),
    category: CATEGORY.LOGIC,
    paramsSchema: {
      type: 'object',
      fields: [
        {
          id: 'origin',
          title: $t('k_6b5c77c2'),
          type: 'string',
          default: '',
          'uc:allowInterop': true,
        },
        {
          id: 'remote',
          title: $t('k_887aea61'),
          type: 'string',
          default: '',
          'uc:allowInterop': true,
        },
        {
          id: 'local',
          title: $t('k_6bb4aebe'),
          type: 'string',
          default: '',
          'uc:allowInterop': true,
        },
        {
          id: 'showTip',
          title: $t('k_94679553'),
          type: 'boolean',
          default: '',
          'uc:allowInterop': true,
        },
      ],
    },
    returnValue: {
      description: $t('k_c5e8c73f'),
      type: 'string',
    },
    execute: async (ctx, params) => {
      const { origin, remote, local, showTip } = params;
      try {
        const result = await nodeDiff3Text(origin, remote, local, { type: 'text/plain', showTip, remainEmptyLine: true });
        if (result.success) {
          return result.data;
        }
      } catch (e) {
        throw new Error($t('k_6c34fb11', { arg_0: e.message }));
      }
      throw new Error($t('k_96e5aa9a'));
    },
  },
];
